import React from "react";
import Modal from "react-modal";
import CloseIcon from "../../../assets/icons/close.svg";
import { ReactComponent as ArrowNextWhite } from "../../../assets/icons/arrowNextWhite.svg";
import { ReactComponent as Warning } from "../../../assets/icons/warning-red.svg";
import StyledModal from "../../common/Modal/StyledModal";
import { useHistory } from "react-router";
import { App } from "../../../routes/Constants";

const PAFRenewModal = ({
  openModal,
  closeModal,
  text: {
    message,
    title
  }
}) => {
  let customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "37%",
    },
  };
  const history = useHistory();
  
  return (
    <StyledModal>
      <Modal
        isOpen={openModal}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Renew Paf Modal"
        overlayClassName="overlay-modal"
        shouldCloseOnOverlayClick={false}
      >
        <button onClick={closeModal} className="close-icon-button ">
          <img src={CloseIcon} alt="Close Icon" />
        </button>
        <div className="wrapper-modal">
          <div className="image">
            {<Warning />}
          </div>
          <div className="main-text-error">{title}</div>
          <div
            className="second-text"
          >
            {message}
          </div>
        </div>
        <div className="wrapper-buttons">
          <button className="cancel mr-6" onClick={() => history.push(App.VIEW_PATIENTS)}>
            Cancel
          </button>
          <button className="red-button" onClick={closeModal}>
            Continue <ArrowNextWhite />
          </button>
        </div>
      </Modal>
    </StyledModal>
  );
};
export default PAFRenewModal;
